/**
 * New feature flags should be in camelCase and follow a boolean naming rule with no prefix and "enabled" (or similar) suffix. {@link https://github.com/MewsSystems/tech-documents/blob/master/rfcs/0032-feature-flag-unification.md#1-flag-key-naming RFC 0032: Feature Flag unification}
 * @example
 * newComponentEnabled
 */
enum FeatureFlag {
    accountBalanceStatementLink = 'accountBalanceStatementLink',
    accountPaymentTerminalsAddPaymentEndpointEnabled = 'accountPaymentTerminalsAddPaymentEndpointEnabled',
    accountingExportConfigurationFormEnabled = 'AccountingExportConfigurationFormEnabled',
    actionAutorizationTokenEnabled = 'actionAutorizationTokenEnabled',
    adaChatBotV2Enabled = 'adaChatBotV2Enabled',
    adaEmbeddedFeatureFlagEnabled = 'adaEmbeddedFeatureFlagEnabled',
    adrDashboardEnabled = 'adrDashboardEnabled',
    advancedMatchAndMergeDuplicateGuestProfilesEnabled = 'advancedMatchAndMergeDuplicateGuestProfilesEnabled',
    advancedReturningClassificationEnabled = 'advancedReturningClassificationEnabled',
    afterStartSMSEnabled = 'afterStartSMSEnabled',
    agingBalanceReportEnabled = 'aging-balance-report-enabled',
    aiMessengerEnabled = 'aiMessengerEnabled',
    allowancesEnabled = 'allowancesEnabled',
    applyFiltersImmediatelyEnabled = 'applyFiltersImmediatelyEnabled',
    assistantAdvanceSearchEnabled = 'assistantAdvanceSearchEnabled',
    assistantAutocompleteEnabled = 'assistantAutocompleteEnabled',
    assistantEnabled = 'assistantEnabled',
    assistantSmartSearchEnabled = 'assistantSmartSearchEnabled',
    assistantSummaryEnabled = 'assistantSummaryEnabled',
    assistantSummaryGuestInsightsEnabled = 'assistantSummaryGuestInsightsEnabled',
    automatedInvoiceFeeSupported = 'automated-invoice-fee-enabled',
    availabilityAdjustmentInPopoverEnabled = 'availabilityAdjustmentInPopoverEnabled',
    availabilityOccupancyReportSharedResourcesTotalsEnabled = 'availabilityOccupancyReportSharedResourcesTotalsEnabled',
    bookingEngineOptionalReservations = 'booking-engine-optional-reservations',
    bulkEditAssignedRatesEnabled = 'bulkEditAssignedRatesEnabled',
    captchaOnSignInEnabled = 'captchaOnSignInEnabled',
    carRegistrationNumberCheckInFormEnabled = 'carRegistrationNumberCheckInFormEnabled',
    cashierShiftPagesMigration = 'cashierShiftPagesMigration',
    centralProductsConfigurePropertyGroupsEnabled = 'centralProductsConfigurePropertyGroupsEnabled',
    centralProductsEditEnabled = 'centralProductsEditEnabled',
    centralProductsEnabled = 'centralProductsEnabled',
    closedBillAddressChangeEnabled = 'closedBillAddressChange',
    communicationHubEnabled = 'communicationHubEnabled',
    companyTerminalPaymentsEnabled = 'companyTerminalPaymentsEnabled',
    contractingActionLogsEnabled = 'contractingActionLogsEnabled',
    contractingCustomerProfileDocumentsEnabled = 'contractingCustomerProfileDocumentsEnabled',
    contractingDocumentGenerationEnabled = 'contractingDocumentGenerationEnabled',
    contractingManualDocumentsEnabled = 'contractingManualDocumentsEnabled',
    contractingTemplateMappingEnabled = 'contractingTemplateMappingEnabled',
    creditNoteBillCounter = 'credit-note-bill-counter',
    creditNoteCounterForItalyBasqueSpain = 'credit-note-counter-for-italy-basque-spain',
    creditNoteCountersDialogRewrite = 'creditNoteCountersDialogRewrite',
    customBackArrowsDisabled = 'customBackArrowsDisabled',
    customMetricsOverviewEnabled = 'customMetricsOverviewEnabled',
    depositLedgerReportEnabled = 'deposit-ledger-report-enabled',
    designSystemAdoptionMeasurementEnabled = 'designSystemAdoptionMeasurementEnabled',
    deviceAuthorizationEnabled = 'deviceAuthorizationEnabled',
    digitalKeyStatusEnabled = 'digitalKeyStatusEnabled',
    disableModals = 'disableModals',
    displayDashboardTilesForAtomizeCampaign = 'displayDashboardTilesForAtomizeCampaign',
    emailLinkSecondFactorEnabled = 'emailLinkSecondFactorEnabled',
    employeeIncentiveCodeEnabled = 'employeeIncentiveCodeEnabled',
    enableCreatingExportSchedule = 'enableCreatingExportSchedule',
    enableFutureUsageForStripeTerminals = 'enable-future-usage-for-stripe-terminals',
    enableGranularViewOfCLTV = 'enableGranularViewOfCLTV',
    enableManagerReportHelp = 'EnableManagerReportHelp',
    enableMulticurrencyServiceConfiguration = 'enable-multicurrency-service-configuration',
    enablePayoutDetailsInPayoutExport = 'enablePayoutDetailsInPayoutExport',
    enableProductClassificationsInput = 'enableProductClassificationsInput',
    enterpriseProductRepricingEnabled = 'enterpriseProductRepricingEnabled',
    enterprisesSelectFieldEnabled = 'enterprisesSelectFieldEnabled',
    excelProcessingChannelManagerRateEnabled = 'excel-processing-channel-manager-rate-enabled',
    exportViewsV2Enabled = 'export-views-v2-enabled',
    extendedHotelConfiguredFields = 'extendedHotelConfiguredFields',
    extendedTicketFormEnabled = 'extendedTicketFormEnabled',
    fePoductCategoryFormEnabled = 'fePoductCategoryFormEnabled',
    feProductListViewEnabled = 'fe-product-list-view-enabled',
    feServiceOverbookingLimitEnabled = 'feServiceOverbookingLimitEnabled',
    financialServicesCapitalAccess = 'financialservices-capital-access',
    financialServicesCapitalPrequalifiedUsersEnabled = 'mews-capital-prequalified-user-access',
    financialServicesEnabled = 'financialServicesEnabled',
    freeResourcesCaptionEnabled = 'freeResourcesCaptionEnabled',
    germanB2bBillingEnabled = 'german-b2b-billing-enabled',
    goLiveAuditListEnabled = 'goLiveAuditListEnabled',
    guestLedgerReportEnabled = 'guest-ledger-report-enabled',
    guestLifetimeValueOverviewEnabled = 'guestLifetimeValueOverviewEnabled',
    guestProfileDietaryRequirementsEnabled = 'guestProfileDietaryRequirementsEnabled',
    guestVerificationPhotoOciConfigurationEnabled = 'guestVerificationPhotoOciConfigurationEnabled',
    hideOldReportEnabled = 'hideOldReportEnabled',
    identityDocumentOptionalNumberEnabled = 'identityDocumentOptionalNumberEnabled',
    identityDocumentScanEnabled = 'identityDocumentScanEnabled',
    identityDocumentScanVerificationEnabled = 'identityDocumentScanVerificationEnabled',
    insightsEnabled = 'insightsEnabled',
    insightsHelpEnabled = 'InsightsHelpEnabled',
    insightsMaintenance = 'insightsMaintenance',
    isNewRelicEventsAPIEnabled = 'isNewRelicEventsAPIEnabled',
    isSecureLoginPageRestrictionEnabled = 'isSecureLoginPageRestrictionEnabled',
    ledgerActivityReportEnabled = 'ledgerActivityReportEnabled',
    legacyFormFloatingBar = 'mgv-floating-form-action-buttons',
    linearOccupancyRatePricingEnabled = 'linearOccupancyRatePricingEnabled',
    linkProductsToReservationsEnabled = 'linkProductsToReservationsEnabled',
    loyaltyImageEnabled = 'loyaltyImageEnabled',
    loyaltyIntegrationEnabled = 'loyaltyIntegrationEnabled',
    mailTemplateEditorCopyRowEnabled = 'mailTemplateEditorCopyRowEnabled',
    mailTemplateEditorTranslatedTagsEnabled = 'mailTemplateEditorTranslatedTagsEnabled',
    mailTemplateExportEnabled = 'mailTemplateExportEnabled',
    manageMailTemplatesPermissionEnabled = 'manageMailTemplatesPermissionEnabled',
    manageUserTrustedDevices = 'manageUserTrustedDevices',
    managerReportEnabled = 'managerReportEnabled',
    managerReportOverviewEnabled = 'managerReportOverviewEnabled',
    managerReportPrintingEnabled = 'managerReportPrintingEnabled',
    managerReportViewModeEnabled = 'managerReportViewModeEnabled',
    marketplaceAndorraPoliceExportIntegrationEnabled = 'marketplaceAndorraPoliceExportIntegrationEnabled',
    marketplaceAvsBaselPoliceExportIntegrationEnabled = 'marketplaceAvsBaselPoliceExportIntegrationEnabled',
    marketplaceBaselPoliceExportIntegrationEnabled = 'marketplaceBaselPoliceExportIntegrationEnabled',
    marketplaceBookDigitalKeyDemo = 'marketplaceBookDigitalKeyDemo',
    marketplaceCzechPoliceExportIntegrationUpdateFormEnabled = 'marketplaceCzechPoliceExportIntegrationUpdateFormEnabled',
    marketplaceDigitalKeyWidgetEnabled = 'marketplaceDigitalKeyWidgetEnabled',
    marketplaceFlexkeepingWidgetEnabled = 'marketplaceFlexkeepingWidgetEnabled',
    marketplaceHousekeepingWidgetEnabled = 'marketplaceHousekeepingWidgetEnabled',
    marketplaceIntegrationTryForFree = 'marketplaceIntegrationTryForFree',
    marketplaceMarkdownTACEnabled = 'marketplaceMarkdownTACEnabled',
    marketplaceOnlyDataSecurityWidgetsEnabled = 'marketplaceOnlyDataSecurityWidgetsEnabled',
    marketplaceServicesCategoryEnabled = 'marketplaceServicesCategoryEnabled',
    marketplaceSmsWidgetEnabled = 'marketplaceSmsWidgetEnabled',
    marketplaceTerminalOrderingEnabled = 'enable-marketplace-terminal-ordering',
    marketplaceUberWidgetEnabled = 'MarketplaceUberWidgetEnabled',
    matchAndMergeDuplicateGuestProfilesEnabled = 'matchAndMergeDuplicateGuestProfilesEnabled',
    merchantPreauthorizationExpirationEnabled = 'merchant-preauthorization-expiration',
    mewsAnalyticsEnabled = 'mews-analytics',
    mewsBiOnboardingEnabled = 'mewsBiOnboardingEnabled',
    mewsGuestLedger = 'mewsGuestLedger',
    mewsTerminalS2AdEnabled = 'mews-terminal-s-2-ad-enabled',
    microFrontendExampleEnabled = 'microFrontendExampleEnabled',
    monthlyServiceRestrictionsRollingMonthsEnabled = 'monthlyServiceRestrictionsRollingMonthsEnabled',
    multiChainNRSEnabled = 'multiChainNRSEnabled',
    multipropertyDashboardEnabled = 'multipropertyDashboardEnabled',
    newAvailabilityCellEnabled = 'newAvailabilityCellEnabled',
    newBillDetail = 'newBillDetail',
    newCustomerPageRouteStructureEnabled = 'newCustomerPageRouteStructureEnabled',
    newCustomerPaymentTabRoutesEnabled = 'newCustomerPaymentTabRoutesEnabled',
    newCustomerProfileFormEnabled = 'newCustomerProfileFormEnabled',
    newDepositLedger = 'new-deposit-ledger',
    newExpansionFrontendPagesEnabled = 'newExpansionFrontendPagesEnabled',
    newFinanceLedgersEnabled = 'newFinanceLedgersEnabled',
    newGuestInHouseReportRouteEnabled = 'newGuestInHouseReportRouteEnabled',
    newMatchQueryEnabled = 'newMatchQueryEnabled',
    newRelicCustomAttributes = 'new-relic-custom-attributes',
    newReservationFromTimelineSlice1 = 'NewReservationFromTimelineSlice1',
    newReservationScreenFloorFilterEnabled = 'newReservationScreenFloorFilterEnabled',
    newResourcesScreenEnabled = 'newResourcesScreenEnabled',
    newRoutingRulesOnAddEnabled = 'newRoutingRulesOnAddEnabled',
    newRoutingRulesPOSEnabled = 'newRoutingRulesPOSEnabled',
    newSendReminderDialog = 'newSendReminderDialog',
    newUpdateIntervalEnabled = 'NewUpdateIntervalEnabled',
    nordicChoiceRateOptionsEnabled = 'nordicChoiceRateOptionsEnabled',
    occupancyDashboardEnabled = 'occupancyDashboardEnabled',
    occupancyInBlocksEnabled = 'occupancyInBlocksEnabled',
    occupancyInBlocksEnabledStage2 = 'occupancyInBlocksEnabledStage2',
    onboardingAuditFinancialIncentiveEnabled = 'onboardingAuditFinancialIncentiveEnabled',
    onboardingAuditLogEnabled = 'onboardingAuditLogEnabled',
    onboardingAuditNewLeftPanelEnabled = 'onboardingAuditNewLeftPanelEnabled',
    onboardingAuditStatusFilterEnabled = 'onboardingAuditStatusFilterEnabled',
    onboardingCompletionCheckEnabled = 'onboardingCompletionCheckEnabled',
    onboardingCreateEnterpriseEnabled = 'onboardingCreateEnterpriseEnabled',
    onboardingGoLiveStatusEnabled = 'onboardingGoLiveStatusEnabled',
    openBalanceEnabled = 'open-balance-enabled',
    openTelemetryEnabled = 'openTelemetryEnabled',
    overrideRestrictionsEnabled = 'override-restrictions-enabled',
    passkeySignInEnabled = 'passkeySignInEnabled',
    passkeySignInUiEnabled = 'passkeySignInUiEnabled',
    passwordScannerEnabled = 'passwordScannerEnabled',
    paymentConfirmationsEnabled = 'payment-confirmations-enabled',
    paymentPlanDetailPageEnabled = 'paymentPlanDetailPageEnabled',
    paymentPlanEnabled = 'payment-plan-enabled',
    paymentRequestCollectTypeEnabled = 'paymentRequestCollectTypeEnabled',
    pciProxyMaintenanceAppBannerEnabled = 'pciProxyMaintenanceAppBannerEnabled',
    pciProxyMaintenanceDisabledPaymentsEnabled = 'pciProxyMaintenanceDisabledPaymentsEnabled',
    percentageDensityValuesEnabled = 'percentageDensityValuesEnabled',
    phishingNotificationEnabled = 'phishingNotificationEnabled',
    pickupDashboardEnabled = 'pickupDashboardEnabled',
    posMicrosConfigurationOutletKeyEnabled = 'posMicrosConfigurationOutletKeyEnabled',
    preferNotes = 'PreferNotes',
    productEditFromEnabled = 'productEditFromEnabled',
    productProvisioningQueueItemViewEnabled = 'productProvisioningQueueItemViewEnabled',
    productServiceFEMigrationEnabled = 'product-service-fe-migration-enabled',
    propertiesNewTableEnabled = 'propertiesNewTableEnabled',
    propertyConfigurationEnablePaymentSettingsMenu = 'property-configuration-enable-payment-settings-menu',
    queryStringCompressionEnabled = 'queryStringCompressionEnabled',
    rateGroupFormMigrationEnabled = 'rateGroupFormMigrationEnabled',
    recurringRoutingRulesEnabled = 'recurringRoutingRulesEnabled',
    reinstateClosedBillToOpenBill = 'reinstateClosedBillToOpenBill',
    relatedGuestsEnabled = 'relatedGuestsEnabled',
    requirePaymentDuringOnlineCheckIn = 'requirePaymentDuringOnlineCheckIn',
    reservationCountException = 'reservationCountException',
    reservationDataDashboardEnabled = 'reservationDataDashboardEnabled',
    reservationLinkToPaymentsEnabled = 'reservationLinkToPaymentsEnabled',
    reservationOverviewPaginationEnabled = 'reservationOverviewPaginationEnabled',
    resourcesBulkCreateEnabled = 'resourcesBulkCreateEnabled',
    resourcesBulkEditEnabled = 'resourcesBulkEditEnabled',
    restrictionSplicingEnabled = 'restrictionSplicingEnabled',
    revPARDashboardEnabled = 'revPARDashboardEnabled',
    revenueDashboardEnabled = 'revenueDashboardEnabled',
    rmsModuleEnabled = 'rmsModuleEnabled',
    routingRulesSlice2Enabled = 'RoutingRulesSlice2Enabled',
    s700OrderingEnabled = 's700OrderingEnabled',
    seasonalAdjustmentDependentRateEnabled = 'seasonalAdjustmentDependentRateEnabled',
    sellLimitsEnabled = 'sell-limits-enabled',
    sendFinancialDocumentToEmailWithTemplatesEnabled = 'sendFinancialDocumentToEmailWithTemplatesEnabled',
    sentryErrorGroupingEnabled = 'sentryErrorGroupingEnabled',
    sentryTracingEnabled = 'sentryTracingEnabled',
    separateSMSTypesEnabled = 'separateSMSTypesEnabled',
    showTrustedDeviceList = 'showTrustedDeviceList',
    smartDetailReturningIconEnabled = 'smartDetailReturningIconEnabled',
    smartTipsGuestSummaryEnabled = 'smartTipsGuestSummaryEnabled',
    smartTipsReservationGuestsEnabled = 'smartTipsReservationGuestsEnabled',
    smartgiftIntegration = 'smartgiftIntegration',
    smsIntegrationEnabled = 'smsIntegrationEnabled',
    ssoSelfServiceUiEnabled = 'sso-self-service-ui',
    steppedCreatePaymentPlanFormEnabled = 'steppedCreatePaymentPlanFormEnabled',
    strawberryReadOnlyFieldsEnabled = 'strawberryReadOnlyFieldsEnabled',
    stripeTerminalConsent = 'stripe-terminal-consent',
    taxwithholdingConfigurationPage = 'taxwithholdingConfigurationPage',
    textMessagingConfigurationEnabled = 'textMessagingConfigurationEnabled',
    textMessagingConfigurationV2Enabled = 'textMessagingConfigurationV2Enabled',
    timelineSpaceSearchNavigationEnabled = 'timelineSpaceSearchNavigationEnabled',
    timelineTouchMoveEnabled = 'timelineTouchMoveEnabled',
    timelineTouchScreenTest = 'timelineTouchScreenTest',
    trialBalanceEnabled = 'trial-balance-enabled',
    trialBalanceFrontendEnabled = 'trialBalanceFrontendEnabled',
    unlinkingPaymentsOnReservationCancellation = 'unlinking-payments-on-reservation-cancellation',
    unsavedChangesDialogInBeForms = 'unsavedChangesDialogInBeForms',
    upsellEnabled = 'upsellEnabled',
    useSimplifiedAccountingCategoryLogicForRebates = 'use-simplified-ac-logic-for-rebates',
    verticalLazyLoadingTimelineEnabled = 'verticalLazyLoadingTimelineEnabled',
    vouchersFETablePMSEnabled = 'vouchersFETablePMSEnabled',
    vouchersFromRatesEnabled = 'vouchersFromRatesEnabled',
    westcordCustomMetricsEnabled = 'westcordCustomMetricsEnabled',
    whitelistedUserEmails = 'whitelistedUserEmails',
    withBankCloseBillEnabled = 'withBankCloseBillEnabled',
}

export default FeatureFlag;
